import styled from "styled-components";
import { Button } from "@mui/material";

interface GridProps {
  $isExpanded: boolean;
  $isSupercarteira: boolean;
  $isSuperExpanded: boolean;
  $isModal: boolean;
}

export const SGrid = styled.div<GridProps>`
  && {
    margin-top: ${({ $isModal }) => ($isModal ? "-54px" : "-54px")};
    display: flex;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.addButtonPrimary};

    width: ${({ $isExpanded, $isSuperExpanded }) =>
      $isExpanded || $isSuperExpanded ? "100%" : "50%"};

    min-height: 56px;

    ${({ $isModal }) => {
      if ($isModal) return "";

      return "position: fixed;";
    }}

    z-index: 1000;

    ${({ $isModal, $isSupercarteira, $isSuperExpanded }) => {
      if ($isModal || $isSuperExpanded) return "";

      return `
        position: absolute;
        max-width: ${$isSupercarteira ? "50%" : "405px"};
      `;
    }}
  }
`;

export const SButton = styled(Button)`
  && {
    display: flex;
    justify-content: center;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    text-transform: none;
    color: ${({ theme }) => theme.colors.addButtonText};
    width: 50%;
  }
`;
